<template>
    <div v-cloak>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="table-layout mt10">
            <el-table ref="multipleTable" :data="staffList" border style="width: 100%" @current-change="handleCurrentChange" @selection-change="handleSelectionChange">
                <el-table-column align="center" :key="Math.random()" width="55" prop="id" label="选择" v-if="!checkBox">
                    <template slot-scope="rows">
                        <el-radio v-model="rceiverId" :label="rows.row.id">&nbsp;</el-radio>
                    </template>
                </el-table-column>
                <el-table-column align="center" :key="Math.random()" type="selection" width="55" v-if="checkBox"></el-table-column>
                <el-table-column align="left" :key="Math.random()" prop="comName" label="机构名称" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" :key="Math.random()" width="130" prop="name" label="员工姓名"></el-table-column>
                <el-table-column align="center" :key="Math.random()" width="130" prop="user.phoneNo" label="用户手机"></el-table-column>
                <el-table-column align="left" :key="Math.random()" width="130" prop="comRoleNames" label="已分配岗位" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" :key="Math.random()" width="130" prop="contactTel" label="联系电话"></el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout mt10">
            <el-pagination background class="pagination-layout mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'

    import { Vue, MsgBox, Routes } from '../../app.vues'
    import userApi from '../../api/user'
    import servicerApi from '../../api/servicer'
    import { getDefaultPageSizes } from '../../../src/app.conf'

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "label": "机构名称",
            "code": "comName",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Text",
            "label": "员工姓名",
            "code": "name",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "联系电话",
            "code": "contactTel",
            "basic": true
        }],
        "sortFields": [{
            "order": "asc",
            "label": "员工姓名",
            "code": "name",
            "enabled": true
        }]
    };

    export default {
        name: 'swb-com-staff-select',
        desc: '公司员工列表',
        props: {
            checkBox: {
                type: Boolean,
                default: false
            },
            isCom: {
                type: Boolean,
                default: false
            },
            includeSubComs: {
                type: Boolean,
                default: false
            },
            comId: {
                type: Number,
                default: null
            },
            comLevel: {
                type: Number,
                default: null
            },
            defMsgReceiverId: {
                type: Number,
                default: null
            },
            selectedIds: {
                type: Array,
                default: null
            },
            excludeAdmin: {
                type: Boolean,
                default: null
            },
            isAll: {
                type: Boolean,
                default: false
            },
            bizUnitId: {
                type: Number,
                default: null
            },
        },
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                staffList: [],
                thisCom: {},
                userContext: {},
                rceiverId: '',
                //排序、搜索
                queryConfig: null,
                queryKey: null,
                queryConfigMap: {},
                queryModel: {
                    filterItems: {
                        disabled: false
                    },
                    sortItemList: [],
                    sortItems: {}
                },
                //
                checkedDelay: 100,
                //是否正在恢复选择状态
                checkedIniting: false,
                //所有选中的条目id
                checkedIds: [],
                selectStaff: null,
                selectStaffList: [],
            }
        },
        watch: {
            comId(oldVal, newVal){
                this.pageSize = this.pageSizes.first();
                this.getStaffList();
            },
            bizUnitId(oldVal, newVal){
                this.pageSize = this.pageSizes.first();
                this.getStaffList();
            },
            includeSubComs(oldVal, newVal){
                this.pageSize = this.pageSizes.first();
                this.getStaffList();
            },
            comLevel(oldVal, newVal){
                this.pageSize = this.pageSizes.first();
                this.getStaffList();
            },
        },
        created: function () {
            this.queryConfig = searchConfigData || {};
            //
            if(this.checkBox) {
                this.checkedIds = this.selectedIds.clone();
                if(!Utils.isNoB(this.checkedIds) && this.checkedIds.length > 0) {
                    for(let i = 0; i < this.checkedIds.length; i++) {
                        let checkedId = this.checkedIds[i];
                        let checkedItem = {
                            id: checkedId
                        };
                        this.selectStaffList.add(checkedItem);
                    }
                }
            }
            //
            this.pageSize = this.pageSizes.first();
            this.rceiverId = this.defMsgReceiverId;
            this.getStaffList();
        },
        methods: {
            handleCurrentChange: function (val) {
                if(!Utils.isNoB(val)) {
                    this.rceiverId = val.id;
                    this.selectStaff = val;
                }
            },
            //
            handleSelectionChange: function (selRows) {
                let self = this;
                if(self.checkedIniting) {
                    return;
                }
                //列表对应的数据源
                let staffList = self.staffList;
                //
                let allIds = staffList.pluck("id");
                let selIds = [];
                selRows.forEach(function (row, index) {
                    selIds.add(row.id);
                    self.addChecked(row);
                });
                //
                let lessIds = Utils.compareArrays(selIds, allIds)["less"];
                lessIds.forEach(function (id, index) {
                    self.delChecked(id);
                })
            },
            //item 接口信息
            addChecked: function (item, val) {
                let id = item.id;
                if(!this.checkBox) {
                    this.checkedIds = [];
                }
                //
                if(!this.checkedIds.contains(id)) {
                    this.checkedIds.add(id);
                    this.selectStaffList.add(item);
                    return item;
                }
                return null;
            },
            delChecked: function (id) {
                let self = this;
                if(self.checkedIds.contains(id)) {
                    self.checkedIds.remove(id);
                    for(let i = 0; i < self.selectStaffList.length; i++) {
                        let selectStaff = self.selectStaffList[i];
                        if(selectStaff.id == id) {
                            self.selectStaffList.splice(i, 1);
                        }
                    }
                    return id;
                }
                return null;
            },
            //
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.queryModel.filterItems.disabled = false;
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = 1;
                this.getStaffList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = val;
                this.getStaffList();
            },
            getStaffList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.comId = self.comId;
                filterItems.bizUnitId = self.bizUnitId;
                filterItems.isAll = self.isAll;
                filterItems.includeSubComs = self.includeSubComs;
                filterItems.disabled = false;
                filterItems.isCom = this.isCom;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                servicerApi.getServicerStaffList(postData, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let data = result.data;
                        self.staffList = data.rows;
                        //
                        let pagination = data.pagination;
                        self.totalCount = pagination.totalCount;
                        // 处理回显
                        if(self.checkBox) {
                            let selectedIds = self.checkedIds;
                            setTimeout(function () {
                                self.selectRows(selectedIds, self.staffList);
                            }, self.checkedDelay);
                        } else {
                            self.checkedIniting = false;
                        }
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            selectRows: function (selectRows, rows) {
                let self = this;
                self.checkedIniting = true;
                if(selectRows) {
                    rows.forEach(function (row) {
                        for(let i = 0; i < selectRows.length; i++) {
                            if(selectRows[i] == row.id) {
                                self.$refs['multipleTable'].toggleRowSelection(row);
                            }
                        }
                    });
                }
                self.checkedIniting = false;
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let result = {};
                if(this.checkBox) {
                    let staffList = this.selectStaffList || [];
                    result.type = "info";
                    result.data = staffList;
                } else {
                    result.id = this.comId;
                    result.defMsgReceiverId = this.rceiverId;
                    let staff = Utils.merge({}, this.selectStaff);
                    result.data = staff;
                    result.type = "info";
                }
                return result;
            },
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/orgStruct/ComStaffSelect.vue